import * as Sentry from "@sentry/react";
import type { AnyRouter } from "@tanstack/react-router";

import { config } from "@/lib/config";

export function initSentry(router: AnyRouter): void {
  if (!import.meta.env.PROD) {
    return;
  }

  Sentry.init({
    dsn: config.SENTRY_DSN,
    release: `admin-dashboard-react@${APP_VERSION}`,
    integrations: [Sentry.tanstackRouterBrowserTracingIntegration(router)],
    tracesSampleRate: 0.1,
    normalizeDepth: 3,
    attachStacktrace: true,
  });
}
